import { mapGetters } from "vuex";
import { CtaTypesEnum } from "@/scripts/common/enums.js";

const FIELD_RADIUS_BY_SHAPE = Object.freeze({
    square: 0,
    rounded: 8,
    pill: 16,
});

export default {
    computed: {
        ...mapGetters("design", ["ctaStyles"]),
        contactFormCtaType() {
            return this.section?.cta?.type ?? CtaTypesEnum.PRIMARY;
        },
        contactFormCtaStyle() {
            return this.ctaStyles?.[this.contactFormCtaType] || {};
        },
        contactFormFieldClasses() {
            const fillStyle = this.contactFormCtaStyle.fillStyle || "solid";
            const shape = this.contactFormCtaStyle.shape || "square";

            return [
                "contact-form--cta-fields",
                `contact-form--cta-${this.contactFormCtaType}`,
                `contact-form--fill-${fillStyle}`,
                `contact-form--shape-${shape}`,
            ];
        },
        contactFormFieldStyleVars() {
            const fillStyle = this.contactFormCtaStyle.fillStyle || "solid";
            const shape = this.contactFormCtaStyle.shape || "square";
            const radiusPx = fillStyle === "underline" ? 8 : (FIELD_RADIUS_BY_SHAPE[shape] ?? 0);

            return {
                "--contact-form-field-radius": `${radiusPx}px`,
            };
        },
    },
};
